import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/cal-ay/packages/features/shell/Shell.tsx");
